import { createSlice } from '@reduxjs/toolkit';

export const careersSlice = createSlice({
  name: 'careers',
  initialState: {
    results: [],
    pageSize: 10,
    page: 0,
    goal: '',
    generatedOn: '',
    today: new Date().toISOString().slice(0, 10).replace(/-/g, ''),
    tagsActive: [],
    keywordFilter: '',
  },
  reducers: {
    setCareers: (state, action) => {
      state.results = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setGoal: (state, action) => {
      state.goal = action.payload;
    },
    setGeneratedOn: (state, action) => {
      if (action.payload.length > 8) {
        state.generatedOn = action.payload.replace(/-/g, '').slice(0, 8);
      } else if (action.payload.length === 8) {
        state.generatedOn = action.payload;
      }
    },
    setTagsActive: (state, action) => {
      state.tagsActive = action.payload;
    },
    setKeywordFilter: (state, action) => {
      state.keywordFilter = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCareers, setPage, setGoal, setGeneratedOn, setTagsActive, setKeywordFilter } = careersSlice.actions;

export default careersSlice.reducer;
